import { AppShell, Burger, Group, Image, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useAppName } from 'contexts/AppProvider';
import Sidebar from 'modules/layouts/Sidebar';
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

const ProtectedLayout: React.FC = () => {
  const [mobileNavOpened, { toggle: toggleMobileNav, close: closeMobileNav }] = useDisclosure();
  const { appName } = useAppName();
  const location = useLocation();

  useEffect(() => {
    closeMobileNav();
  }, [location.pathname, closeMobileNav]);

  return (
    <AppShell
      layout='alt'
      navbar={{
        width: 256,
        breakpoint: 'md',
        collapsed: { mobile: !mobileNavOpened }
      }}
      header={{ height: { base: 60, md: 0 } }}
      padding={{ base: 16, md: 32 }}
    >
      <AppShell.Header hiddenFrom='md'>
        <Group h='100%' px='md' justify='space-between'>
          <Group gap={8}>
            <Image src='/logo/logo_icon-dacum.svg' h={28} w={28} />
            <Text fw={700} fz='lg' tt='uppercase'>
              {appName || 'DACUM'}
            </Text>
          </Group>
          {!mobileNavOpened && (
            <Burger opened={mobileNavOpened} onClick={toggleMobileNav} size='sm' />
          )}
        </Group>
      </AppShell.Header>

      <Sidebar onMobileNavClose={closeMobileNav} mobileNavOpened={mobileNavOpened} />

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
};

export default ProtectedLayout;
